export default __webpack_public_path__ + "locales/ja-JP/Settings.json?hash=38ed82b35d99260f7350cb7c1675889d";